import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ElementUI from "element-ui";

import order_confirm from './views/order/order_confirm.vue'
import order_detail from './views/order/order_detail.vue'
import account_son from './views/account/account_son.vue'
import account_password from './views/account/account_password.vue'
import difference_confirm from './views/difference/difference_confirm.vue'
import difference_detail from './views/difference/difference_detail.vue'
import finance_confirm from './views/finance/finance_confirm.vue'
import finance_detail from './views/finance/finance_detail.vue'
import label_exterior from './views/label/label_exterior.vue'
import label_item_code from './views/label/label_item_code.vue'
import label_search from './views/label/label_search.vue'
import label_detail from './views/label/label_detail.vue'
import power_role from './views/power/power_role.vue'
import return_goods_confirm from './views/return_goods/return_goods_confirm.vue'
import return_goods_detail from './views/return_goods/return_goods_detail.vue'

Vue.use(Router)


const router = new Router({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      children: [
        {
          //订单确认
          path: 'order_confirm',
          component: order_confirm,
        },
        // 订单明细
        { 
          path: 'order_detail', 
          component: order_detail, 
          name: 'order_detail' 
        },
        {
          //子账户管理
          path: 'account_son',
          component: account_son
        },
        {
          //修改密码
          path: 'account_password',
          component: account_password
        },
        {
          //差价单确认
          path: 'difference_confirm',
          component: difference_confirm
        },
        //差价单明细
        {
          path: 'difference_detail',
          component: difference_detail,
          name: 'difference_detail'
        },
        {
          //对账单确认
          path: 'finance_confirm',
          component: finance_confirm
        },
        {
          //对账单明细
          path: 'finance_detail', 
          component: finance_detail,
          name: 'finance_detail' 
        },
        {
          //外箱大标签
          path: 'label_exterior',
          component: label_exterior
        },
        {
          //实物二维码
          path: 'label_item_code',
          component: label_item_code
        },
        {
          //标签打印查询订单
          path: 'label_search',
          component: label_search,
          
        },
        // 标签打印订单明细
        { 
          path: 'label_detail', 
          component: label_detail, 
          name: 'label_detail' 
        },
        {
          //角色管理
          path: 'power_role',
          component: power_role
        },
        {
          //退货单确认
          path: 'return_goods_confirm',
          component: return_goods_confirm
        },
        //退货单明细
        { 
          path: 'return_goods_detail', 
          component: return_goods_detail, 
          name: 'return_goods_detail' 
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    }
  ]
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    let token = localStorage.getItem('Authorization');
    if (token === null || token === '') {
      ElementUI.Message({
        title: "警告",
        message: '请先登录！',
        type: "warning"
      })
      setTimeout(() => {
        next('/login');
      }, 2000)
    } else {
      next();
    }
  }
});

export default router
